<template>
  <div class="min-h-screen bg-nera-elevated-1 flex items-center justify-center p-6">
    <div class="w-full max-w-md rounded-3xl bg-nera-elevated-2 border border-nera-light-border p-10 text-center shadow-2xl">

      <div class="flex justify-center mb-8">
        <div
          class="p-4 w-16 h-16 rounded-full bg-nera-elevated-1 border border-emerald-300 flex items-center justify-center">
          <svg class="w-7 h-7 text-emerald-600" fill="none" viewBox="0 0 24 24" stroke="currentColor"
            stroke-width="1.5">
            <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5" />
          </svg>
        </div>
      </div>

      <p class="text-xs uppercase tracking-widest text-nera-muted-light mb-3">Payment Confirmed</p>
      <h1 class="text-3xl! font-bold text-nera-text-light mb-3 tracking-wide">
        You're on <span class="text-nera-light-text-strong">{{ planName }}</span>
      </h1>
      <p class="text-sm text-nera-muted-light leading-relaxed mb-10!">
        Your subscription is now active. Credits have been added to your account and are ready to use.
      </p>

      <button @click="goHome"
        class="p-4 rounded-xl border-[0.5px]! border-transparent! bg-nera-accent!  text-sm font-bold! text-nera-text-dark! hover:bg-nera-accent-hover! transition-colors!  tracking-wider">
        Go to Dashboard
      </button>

    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRouter } from 'vue-router'

const router = useRouter()

const planName = computed(() => {
  const params = new URLSearchParams(window.location.search)
  return params.get('plan')
})

const goHome = () => router.push('/')
</script>
